import Glide from '@glidejs/glide';

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".glide-endorsements")) {
    let glideEndorsements = new Glide('.glide-hoy', {
      type: 'carousel',
      perView: 3,
      gap: 30,
      focusAt: 'center',
      breakpoints: {
        1024: {
          perView: 3,
          gap: 15,
        },
        800: {
          perView: 2,
          gap: 10,
        },
        400: {
          perView: 1,
        },
      },
      animationDuration: 800,
      gap: 40,

    });
    glideEndorsements.mount();
  }
});
